const bytesToSize = (bytes, precision = 0) => {
  const kilobyte = 1000;
  const megabyte = kilobyte * 1000;

  if (bytes >= megabyte) {
    return `${(bytes / megabyte).toFixed(precision).replace(/\.0+$/, "")} MB`;
  }

  return `${(bytes / kilobyte).toFixed(precision).replace(/\.0+$/, "")} KB`;
};

export default bytesToSize;
